import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button';
import CreatePostHandler from '../../containers/create-post-handler';
import ensureAuth from '../../hoc/ensure-auth';
import withTranslate from '../../hoc/with-translate';

const ButtonSecure = ensureAuth(Button);

const CreatePostButton = ({ t, categorySlug }) =>
  <CreatePostHandler categorySlug={categorySlug}>
    <ButtonSecure>
      {t('create-post-button.create-new-post')}
    </ButtonSecure>
  </CreatePostHandler>;

CreatePostButton.propTypes = {
  categorySlug: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslate(CreatePostButton);



// WEBPACK FOOTER //
// ./app/components/create-post-button/create-post-button.js